import{options as n,Fragment as o}from"preact";"undefined"!=typeof window&&window.__PREACT_DEVTOOLS__&&window.__PREACT_DEVTOOLS__.attachPreact("10.0.5",n,{Fragment:o});
//# sourceMappingURL=devtools.module.js.map
